<template>
  <footer class="relative bg-blueGray-200 pt-8 pb-6">
    <div
        class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
        style="transform: translateZ(0);"
    >
      <svg
          class="absolute bottom-0 overflow-hidden"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          version="1.1"
          viewBox="0 0 2560 100"
          x="0"
          y="0"
      >
        <polygon
            class="text-blueGray-200 fill-current"
            points="2560 0 2560 100 0 100"
        ></polygon>
      </svg>
    </div>
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap text-center lg:text-left justify-content-center">
        <div class="w-full lg:w-6/12 px-4 justify-content-center">
          <h4 class="text-3xl font-semibold">Let's keep in touch!</h4>
          <h5 class="text-lg mt-2 mb-2 text-blueGray-600">
            E-mail:1596420313@qq.com
          </h5>
          <h5 class="text-lg mt-0 mb-2 text-blueGray-600">
            Wechat:18875969650
          </h5>
        </div>
<!--        <div class="w-full lg:w-6/12 px-4">-->
<!--          <div class="flex flex-wrap items-top mb-6">-->
<!--            <div class="w-full lg:w-4/12 px-4 ml-auto">-->
<!--              <span-->
<!--                  class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"-->
<!--              >-->
<!--                Useful Links-->
<!--              </span>-->
<!--              <ul class="list-unstyled">-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://www.creative-tim.com/presentation?ref=vn-footer"-->
<!--                  >-->
<!--                    About Us-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://blog.creative-tim.com?ref=vn-footer"-->
<!--                  >-->
<!--                    Blog-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://www.github.com/creativetimofficial?ref=vn-footer"-->
<!--                  >-->
<!--                    Github-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://www.creative-tim.com/bootstrap-themes/free?ref=vn-footer"-->
<!--                  >-->
<!--                    Free Products-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            <div class="w-full lg:w-4/12 px-4">-->
<!--              <span-->
<!--                  class="block uppercase text-blueGray-500 text-sm font-semibold mb-2"-->
<!--              >-->
<!--                Other Resources-->
<!--              </span>-->
<!--              <ul class="list-unstyled">-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://github.com/creativetimofficial/vue-notus/blob/main/LICENSE.md?ref=vn-footer"-->
<!--                  >-->
<!--                    MIT License-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://creative-tim.com/terms?ref=vn-footer"-->
<!--                  >-->
<!--                    Terms & Conditions-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://creative-tim.com/privacy?ref=vn-footer"-->
<!--                  >-->
<!--                    Privacy Policy-->
<!--                  </a>-->
<!--                </li>-->
<!--                <li>-->
<!--                  <a-->
<!--                      class="text-blueGray-600 hover:text-blueGray-800 font-semibold block pb-2 text-sm"-->
<!--                      href="https://creative-tim.com/contact-us?ref=vn-footer"-->
<!--                  >-->
<!--                    Contact Us-->
<!--                  </a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <hr class="my-6 border-blueGray-300"/>
      <div
          class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-6/12 px-4 mx-auto text-center">
          <div class="text-sm text-blueGray-500 font-semibold py-1 mb-2">
            Copyright © {{ date }} Bioengineering by Fu Lab <br>
            Guangdong University of Technology, Guangzhou, Guangdong, China
          </div>
          <a class="link" href="https://beian.miit.gov.cn/" target="_blank"
          >粤ICP备2023020986号</a
          >
          <div style="width:300px;margin:0 auto; padding:20px 0;">
            <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img :src="police" style="float:left;"/><p
                  style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备
                44082502000049号</p></a>
          </div>

          <div class="text-sm text-blueGray-500 font-semibold py-1">

          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import police from "@/assets/img/police.png"
export default {
  data() {
    return {
      date: new Date().getFullYear(),
      police
    };
  },
};
</script>
.link:link {
color: black;
}

.link:visited {
color: black;
}

.link:hover {
color: #e91e63;
}